<template>
    <div style="
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        background-color: #EDF5F3;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        padding: 100px 20px 20px;
    ">
            <h4 class="text-center" style="
            font-size: 26px;
                line-height: 34px;
                color: #000;
                letter-spacing: 0.31px;
                font-weight: 500;
                margin-bottom: 5px;
                width: 100%;
            "  v-html="defaultCartLanguage.confirmation_heading"></h4>
            <p class="text-center" style="margin-bottom: 25px">{{ defaultCartLanguage.confirmation_subheading }}<p>
            <div class="form-group" style="width: 100%;">
                <input class="form-control text-center" placeholder="Email" v-model="localEmail">
            </div>
            <button style="margin-bottom: 30px; display: flex; justify-content: center; align-items: center; font-weight: bold; width: calc(100vw - 40px); height: 40px;" class="btn" @click.prevent="updateLatestOrderWithEmail(localEmail)" :disabled="localEmail.length < 1">Invia</button>
            <button v-if="!localEmail" style="display: flex; justify-content: center; align-items: center; font-weight: bold; width: calc(100vw - 40px); height: 40px;" class="btn" @click.prevent="goHome()">Torna alla schermata principale</button>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
    data() {
        return  {
            localEmail: '',
        }
    },

    computed: {
        ...mapGetters(['defaultCartLanguage'])
    },

    methods: {
        ...mapActions(['updateLatestOrderWithEmail', 'hideOrderConfirmation']),
        goHome () {
            this.hideOrderConfirmation()
            window.location.reload()
        }
    }
}
</script>
